"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStylesByVariant = exports.baseButtonStyles = exports.Button = void 0;
var _react = _interopRequireDefault(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _reactTracking = require("react-tracking");
var _Link = require("../link/Link");
const baseButtonStyles = theme => ({
  alignItems: 'center',
  border: '0',
  borderRadius: theme === null || theme === void 0 ? void 0 : theme.buttonShape.default,
  display: 'flex',
  height: '40px',
  fontSize: theme === null || theme === void 0 ? void 0 : theme.fontSizes.small,
  fontWeight: theme === null || theme === void 0 ? void 0 : theme.fontWeights.medium,
  justifyContent: 'center',
  outline: 'none',
  textDecoration: 'none',
  transition: 'background-color .2s',
  '&:hover': {
    cursor: 'pointer'
  },
  '&:disabled': {
    opacity: '0.5'
  }
});
exports.baseButtonStyles = baseButtonStyles;
const getStylesByVariant = _ref => {
  let {
    color,
    theme
  } = _ref;
  const colors = {
    primary: {
      backgroundColor: theme === null || theme === void 0 ? void 0 : theme.colors.primary,
      color: theme === null || theme === void 0 ? void 0 : theme.colors.primaryContrast,
      '&:hover:enabled': {
        backgroundColor: theme === null || theme === void 0 ? void 0 : theme.colors.primaryHover
      },
      '&:focus': {
        backgroundColor: theme === null || theme === void 0 ? void 0 : theme.colors.primaryHover
      }
    },
    primaryLightest: {
      backgroundColor: theme === null || theme === void 0 ? void 0 : theme.colors.primaryLightest,
      color: theme === null || theme === void 0 ? void 0 : theme.colors.secondary,
      '&:hover:enabled': {
        backgroundColor: theme === null || theme === void 0 ? void 0 : theme.colors.primaryLight,
        color: theme === null || theme === void 0 ? void 0 : theme.colors.secondary
      }
    },
    red: {
      backgroundColor: theme === null || theme === void 0 ? void 0 : theme.colors.red,
      color: theme === null || theme === void 0 ? void 0 : theme.colors.redContrast,
      '&:hover:enabled': {
        backgroundColor: theme === null || theme === void 0 ? void 0 : theme.colors.primaryDark
      }
    },
    secondary: {
      backgroundColor: theme === null || theme === void 0 ? void 0 : theme.colors.secondary,
      color: theme === null || theme === void 0 ? void 0 : theme.colors.secondaryContrast,
      '&:hover:enabled': {
        backgroundColor: theme === null || theme === void 0 ? void 0 : theme.colors.secondaryHover
      }
    },
    white: {
      backgroundColor: theme === null || theme === void 0 ? void 0 : theme.colors.primaryContrast,
      border: `2px solid ${theme === null || theme === void 0 ? void 0 : theme.colors.secondary}`,
      color: theme === null || theme === void 0 ? void 0 : theme.colors.secondary,
      '&:hover:enabled': {
        backgroundColor: theme === null || theme === void 0 ? void 0 : theme.colors.grey[350]
      }
    }
  };
  return colors[color] || '';
};
exports.getStylesByVariant = getStylesByVariant;
const shapes = {
  default: '25px',
  round: '25px',
  square: 0
};
const getButtonStyles = _ref2 => {
  let {
    borderColor,
    buttonShape,
    color,
    fontSize,
    fontWeight,
    style,
    textColor,
    textDecoration,
    theme,
    type
  } = _ref2;
  if (type === 'link') {
    return {
      ...(0, _Link.baseLinkStyles)({
        theme,
        color,
        fontSize,
        fontWeight,
        textDecoration
      }),
      ...(textColor === 'textPrimary' && {
        color: theme === null || theme === void 0 ? void 0 : theme.colors.textPrimary
      }),
      background: 'none',
      borderWidth: '0px'
    };
  }
  return {
    ...baseButtonStyles(theme),
    ...getStylesByVariant({
      color,
      theme
    }),
    borderRadius: buttonShape && shapes[buttonShape] || (theme === null || theme === void 0 ? void 0 : theme.buttonShape.default),
    ...(borderColor === 'grey' && {
      borderColor: theme === null || theme === void 0 ? void 0 : theme.colors.grey[400]
    }),
    ...(textColor === 'textPrimary' && {
      color: theme === null || theme === void 0 ? void 0 : theme.colors.textPrimary
    }),
    ...style
  };
};
const StyledButton = _styled.default.button(getButtonStyles);
const Button = _ref3 => {
  let {
    borderColor,
    buttonShape = 'default',
    children,
    className,
    color = 'primary',
    disabled = false,
    fontSize,
    fontWeight,
    id,
    name,
    style,
    textColor,
    textDecoration,
    type = 'button',
    onClick = () => {},
    onMouseDown
  } = _ref3;
  const {
    trackEvent
  } = (0, _reactTracking.useTracking)();
  const handleClick = e => {
    if (type === 'link') {
      e.preventDefault();
    }
    onClick();
    trackEvent({
      event_name: `${name}-button`,
      event_type: 'click'
    });
  };
  return /*#__PURE__*/_react.default.createElement(StyledButton, {
    borderColor: borderColor,
    buttonShape: buttonShape,
    className: className,
    color: color,
    disabled: disabled
    // @ts-ignore
    ,
    fontSize: fontSize
    // @ts-ignore
    ,
    fontWeight: fontWeight,
    id: id,
    name: name,
    style: style,
    textColor: textColor
    // @ts-ignore
    ,
    textDecoration: textDecoration
    // @ts-ignore
    ,
    type: type,
    onClick: handleClick,
    onMouseDown: onMouseDown
  }, children);
};
exports.Button = Button;